import { render, staticRenderFns } from "./PackagesFilterRow.vue?vue&type=template&id=4824840d&lang=pug&"
import script from "./PackagesFilterRow.vue?vue&type=script&lang=js&"
export * from "./PackagesFilterRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports